"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useContext, useMemo } from "react";
import type { ApiWave } from "@/generated/models/ApiWave";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { AuthContext } from "@/components/auth/Auth";
import { WaveLeaderboardGalleryItem } from "./WaveLeaderboardGalleryItem";
import type { WaveDropsLeaderboardSort } from "@/hooks/useWaveDropsLeaderboard";
import { useWaveDropsLeaderboard } from "@/hooks/useWaveDropsLeaderboard";
interface WaveLeaderboardGalleryProps {
  readonly wave: ApiWave;
  readonly sort: WaveDropsLeaderboardSort;
  readonly onDropClick: (drop: ExtendedDrop) => void;
}
export const WaveLeaderboardGallery: React.FC<WaveLeaderboardGalleryProps> = t0 => {
  const $ = _c(28);
  const {
    wave,
    sort,
    onDropClick
  } = t0;
  const {
    connectedProfile
  } = useContext(AuthContext);
  const t1 = connectedProfile?.handle ?? null;
  let t2;
  if ($[0] !== sort || $[1] !== t1 || $[2] !== wave.id) {
    t2 = {
      waveId: wave.id,
      connectedProfileHandle: t1,
      sort
    };
    $[0] = sort;
    $[1] = t1;
    $[2] = wave.id;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    drops,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage
  } = useWaveDropsLeaderboard(t2);
  const [animationKey, setAnimationKey] = React.useState(0);
  const [previousSort, setPreviousSort] = React.useState(sort);
  let t3;
  let t4;
  if ($[4] !== previousSort || $[5] !== sort) {
    t3 = () => {
      if (previousSort !== sort) {
        setPreviousSort(sort);
        setAnimationKey(_temp);
      }
    };
    t4 = [sort, previousSort];
    $[4] = previousSort;
    $[5] = sort;
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  React.useEffect(t3, t4);
  let t5;
  if ($[8] !== drops) {
    t5 = drops?.filter(_temp2) || [];
    $[8] = drops;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const dropsWithMedia = t5;
  if (isFetching && dropsWithMedia.length === 0) {
    let t6;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <div className="tw-flex tw-justify-center tw-items-center tw-h-32"><div className="tw-text-iron-500 tw-text-sm">Loading drops...</div></div>;
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    return t6;
  }
  if (dropsWithMedia.length === 0) {
    let t6;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <div className="tw-flex tw-justify-center tw-items-center tw-h-32 tw-text-iron-500 tw-text-sm">No drops to show</div>;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    return t6;
  }
  let t6;
  if ($[12] !== animationKey || $[13] !== dropsWithMedia || $[14] !== onDropClick || $[15] !== sort) {
    let t7;
    if ($[17] !== animationKey || $[18] !== onDropClick || $[19] !== sort) {
      t7 = drop_0 => <WaveLeaderboardGalleryItem key={drop_0.id} drop={drop_0} onDropClick={onDropClick} activeSort={sort} animationKey={animationKey} />;
      $[17] = animationKey;
      $[18] = onDropClick;
      $[19] = sort;
      $[20] = t7;
    } else {
      t7 = $[20];
    }
    t6 = dropsWithMedia.map(t7);
    $[12] = animationKey;
    $[13] = dropsWithMedia;
    $[14] = onDropClick;
    $[15] = sort;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[21] !== fetchNextPage || $[22] !== hasNextPage || $[23] !== isFetchingNextPage) {
    t7 = hasNextPage && <div className="tw-col-span-full tw-flex tw-justify-center tw-mt-4 tw-mb-2"><button onClick={() => fetchNextPage()} disabled={isFetchingNextPage} className="tw-px-4 tw-py-2 tw-rounded-lg tw-text-sm tw-transition tw-bg-iron-900 tw-text-iron-400 tw-border tw-border-solid tw-border-iron-800 desktop-hover:hover:tw-bg-iron-800 desktop-hover:hover:tw-text-iron-300">{isFetchingNextPage ? "Loading more..." : "Load more drops"}</button></div>;
    $[21] = fetchNextPage;
    $[22] = hasNextPage;
    $[23] = isFetchingNextPage;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  let t8;
  if ($[25] !== t6 || $[26] !== t7) {
    t8 = <div className="tw-@container"><div className="tw-grid @lg:tw-grid-cols-2 @3xl:tw-grid-cols-3 tw-gap-x-4 tw-gap-y-8">{t6}{t7}</div></div>;
    $[25] = t6;
    $[26] = t7;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  return t8;
};
function _temp(prev) {
  return prev + 1;
}
function _temp2(drop) {
  return (drop.parts?.[0]?.media?.length ?? 0) > 0;
}